import { Quotes } from '@phosphor-icons/react';

export function Testimonial() {
  return (
    <section className="border-y border-line bg-[#F8F9FA] py-24">
      <div className="mx-auto max-w-4xl px-6 text-center">
        <div className="mb-8 flex justify-center text-ink-faint">
          <Quotes weight="fill" size={30} />
        </div>
        <blockquote className="mb-10 font-editorial text-3xl italic leading-tight text-ink md:text-5xl">
          &ldquo;I kept saying I&apos;d build my portfolio someday. Turns out someday was just me not having a tool that got out of my way.&rdquo;
        </blockquote>
        <div className="flex items-center justify-center gap-4">
          <div className="h-12 w-12 overflow-hidden rounded-full border border-line">
            <img
              src="https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&q=80"
              alt="portrait"
              className="h-full w-full object-cover"
            />
          </div>
          <div className="text-left">
            <p className="text-sm font-semibold text-ink">Someone, probably</p>
            <p className="font-mono text-xs uppercase tracking-wide text-ink-muted">
              First user · still figuring it out
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
